var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "function-debugging" },
    [
      !_vm.isLoading
        ? _c("div", { staticClass: "function-debugging__wrapper" }, [
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col col-12 col-md-6 col-xl-4" },
                [
                  _c("c-input", {
                    attrs: {
                      type: "select",
                      "floating-label": "Показатель",
                      items: _vm.collections.statuses,
                    },
                    model: {
                      value: _vm.form.status,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "status", $$v)
                      },
                      expression: "form.status",
                    },
                  }),
                ],
                1
              ),
            ]),
            _c(
              "div",
              { staticClass: "function-debugging__tasks" },
              [
                _c("h3", { staticClass: "function-debugging__tasks-title" }, [
                  _vm._v("Задачи по отладке функции"),
                ]),
                _c(
                  "draggable",
                  {
                    attrs: {
                      group: "group",
                      "force-fallback": true,
                      "ghost-class": "sortable__ghost",
                      disabled: _vm.form.tasks.length < 2,
                    },
                    model: {
                      value: _vm.form.tasks,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "tasks", $$v)
                      },
                      expression: "form.tasks",
                    },
                  },
                  _vm._l(_vm.form.tasks, function (task, i) {
                    return _c(
                      "div",
                      {
                        key: task.id,
                        staticClass: "function-debugging__tasks-item row",
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "col col-10 col-md-10 col-xl-10" },
                          [
                            _c("c-input", {
                              ref: "task-" + i,
                              refInFor: true,
                              attrs: {
                                type: "textarea",
                                "floating-label": "Описание задачи",
                                clearable: true,
                              },
                              model: {
                                value: task.value,
                                callback: function ($$v) {
                                  _vm.$set(task, "value", $$v)
                                },
                                expression: "task.value",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          {
                            staticClass:
                              "function-debugging__tasks-item-actions col col-2 col-md-2 col-xl-2",
                          },
                          [
                            _vm.form.tasks.length > 1
                              ? _c("c-button", {
                                  directives: [
                                    {
                                      name: "b-popover",
                                      rawName: "v-b-popover.hover.blur.top",
                                      value: "Удалить",
                                      expression: "'Удалить'",
                                      modifiers: {
                                        hover: true,
                                        blur: true,
                                        top: true,
                                      },
                                    },
                                  ],
                                  staticClass:
                                    "function-debugging__tasks-item-remove",
                                  attrs: {
                                    icon: { icon: "trash", color: "secondary" },
                                    size: "iconic",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.deleteTask(task.id)
                                    },
                                  },
                                })
                              : _vm._e(),
                            _vm.form.tasks.length > 1
                              ? _c("c-button", {
                                  directives: [
                                    {
                                      name: "b-popover",
                                      rawName: "v-b-popover.html",
                                      value: {
                                        container: "#app",
                                        trigger: "hover blur",
                                        boundary: "window",
                                        content: "Переместить",
                                        placement: "top",
                                      },
                                      expression:
                                        "{\n                container: '#app',\n                trigger: 'hover blur',\n                boundary: 'window',\n                content: 'Переместить',\n                placement: 'top',\n              }",
                                      modifiers: { html: true },
                                    },
                                  ],
                                  staticClass:
                                    "function-debugging__tasks-item-move",
                                  attrs: {
                                    size: "iconic",
                                    icon: "arrows-constructor",
                                  },
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]
                    )
                  }),
                  0
                ),
                !_vm.form.tasks.length
                  ? _c("p", { staticClass: "function-debugging__empty" }, [
                      _vm._v("Задач пока не добавлено"),
                    ])
                  : _vm._e(),
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col col-xl-12 col-md-12 col-12" },
                    [
                      _c("c-button", {
                        attrs: {
                          responsive: true,
                          size: "small",
                          label: "Добавить задачу",
                          icon: { icon: "plus", color: "primary" },
                          disabled: _vm.addTaskIsDisabled,
                        },
                        on: { click: _vm.addTask },
                      }),
                    ],
                    1
                  ),
                ]),
              ],
              1
            ),
            _c(
              "div",
              {
                staticClass: "function__actions",
                class: { "function__actions--fixed": _vm.actionsIsFixed },
              },
              [
                _c("c-button", {
                  staticClass: "function__action",
                  attrs: { label: "Отменить", size: "large" },
                  on: { click: _vm.onReset },
                }),
                _c("c-button", {
                  staticClass: "function__action",
                  attrs: {
                    label: "Сохранить",
                    size: "large",
                    color: "primary",
                  },
                  on: { click: _vm.onSubmit },
                }),
              ],
              1
            ),
          ])
        : _vm._e(),
      _vm.isLoading
        ? _c("c-loader", {
            attrs: {
              label: "Данные загружаются",
              active: _vm.isLoading,
              height: "400",
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }